export default __webpack_public_path__ + "static/media/association_poster.023fa67d.jpg";